import { z, ZodType } from 'zod'

import { WorkspacePrebidModuleSlice } from 'features/globalSetup/contexts/PrebidModulesContext'
import { yieldbirdStatuses } from 'features/globalSetup/types/yieldbirdStatus'
import { commonSchema } from './commonSchema'

export const enabled: ZodType<boolean> = z.boolean()

export const editSchema = z.intersection(
  z.object({
    enabled,
    status: z.enum(yieldbirdStatuses),
  }),
  commonSchema,
)

export type EditSchema = z.infer<typeof editSchema>

export const editSchemaDefault = (
  workspacePrebidModule: WorkspacePrebidModuleSlice,
): EditSchema => {
  const {
    enabled,
    prebidModule: { account, id },
    status,
  } = workspacePrebidModule

  return {
    accountType: account,
    enabled,
    prebidModuleId: id,
    status,
  }
}
